import { apiGet } from "./api";

const LOGO_KEY = "omni:branding:logo";
export const LOGO_EVENT = "omni:branding:logo-updated";

const DEFAULT_FAVICON = `data:image/svg+xml,${encodeURIComponent(
  "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'><defs><linearGradient id='g' x1='0' y1='0' x2='1' y2='1'><stop stop-color='#38bdf8'/><stop offset='1' stop-color='#f97316'/></linearGradient></defs><rect width='64' height='64' rx='16' fill='url(#g)'/><text x='32' y='38' text-anchor='middle' font-family='Segoe UI, Arial, sans-serif' font-size='24' font-weight='700' fill='#0b1224'>OD</text></svg>"
)}`;

const applyFavicon = (href: string | null) => {
  if (typeof document === "undefined") return;
  const nextHref = href || DEFAULT_FAVICON;
  let link = document.querySelector<HTMLLinkElement>("link[rel='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = nextHref;
};

export const getLogoDataUrl = () => {
  if (typeof window === "undefined") return null;
  return window.localStorage.getItem(LOGO_KEY);
};

const setLogoDataUrl = (value: string | null) => {
  if (typeof window === "undefined") return;
  if (value) {
    window.localStorage.setItem(LOGO_KEY, value);
  } else {
    window.localStorage.removeItem(LOGO_KEY);
  }
  applyFavicon(value);
  window.dispatchEvent(new Event(LOGO_EVENT));
};

type BrandingResponse = {
  logoUrl?: string | null;
};

export const fetchBranding = async () => {
  const data = await apiGet<BrandingResponse>("/branding");
  const logoUrl = data?.logoUrl ?? null;
  setLogoDataUrl(logoUrl);
  return logoUrl;
};

export const ensureBrandingLoaded = async () => {
  const cached = getLogoDataUrl();
  applyFavicon(cached);
  if (cached) return cached;
  applyFavicon(null);
  return fetchBranding();
};

export const refreshBranding = async () => fetchBranding();
